export { webSocket as websocket } from './observable/dom/webSocket';
